import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { cleanString } from "../utils";
import { LoadedSince } from "../shared-components/LoadedSince";
import Pagination from "../shared-components/Pagination";

import { genericErrorLoadingMessage } from "./utils";

import { usePermissionValidator } from "../api/UserPermissionValidators";
import { useGetWorkflowsIQA } from "../api/WorkflowData";
import { LazyLoadTable } from "../shared-components/LazyLoadTable";
import InternalQALazyRow from "./InternalQALazyRow";
import InternalQALazyRowV2 from "./InternalQALazyRowV2";
import { useFamaFlags } from "../api/FamaFlags";
import { useQueryClient } from "react-query";

const pageSize = 15;

const InternalQATab = () => {
  const { canCancelMisconduct } = usePermissionValidator();
  const { enableIqaRowFetch } = useFamaFlags();
  const {
    isLoading: workflowLoading,
    data: workflowData,
    mutate: workflowGet,
    error: workflowError,
  } = useGetWorkflowsIQA();
  const client = useQueryClient();
  const { search } = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);
  const [filter, setFilter] = useState(searchParams.get("search") || "");
  const [page, setPage] = useState(1);
  const SearchName = searchParams.get("search");
  const SearchPage = searchParams.get("page");

  const tableHeader = [
    "Name / Company",
    "Status",
    "Previously QA?",
    "Check Type / Behavior Kit",
    "Date Added",
    "Date Due",
    "Report ID",
    "Client Reference ID",
  ];
  if (canCancelMisconduct) {
    tableHeader.push("Cancel Report");
  }

  const [since, setSince] = useState<number | undefined>(undefined);

  useEffect(() => {
    setFilter(cleanString(SearchName?.split(" ").join("%20") ?? ""));
    setPage(Number(1));
  }, [SearchName]);

  useEffect(() => {
    setPage(Number(SearchPage || "1"));
  }, [SearchPage]);

  useEffect(() => {
    workflowGet({
      search: filter,
      page: page - 1,
      page_size: pageSize,
    });
    setSince(new Date().getTime());
  }, [workflowGet, filter, page]);

  if (workflowError) {
    return (
      <div className="p-4 rounded-xl bg-red-300 text-red-900">
        {genericErrorLoadingMessage}
      </div>
    );
  }

  return (
    <>
      <LoadedSince
        reportData={{ timestamp: since }}
        onClear={async () => {
          workflowGet({
            search: filter,
            page: page - 1,
            page_size: pageSize,
          });
          await client.refetchQueries({ queryKey: ["workflowRun"] });
        }}
      />
      <LazyLoadTable
        parentRows={(workflowData && workflowData[0]) ?? []}
        parentLoading={workflowLoading}
        headers={tableHeader}
        emptyMessage={"No search items"}
        keyField={"external_id"}
        rowFunction={
          enableIqaRowFetch ? InternalQALazyRowV2 : InternalQALazyRow
        }
      />
      {!workflowLoading && workflowData && (
        <Pagination
          pageSize={pageSize}
          currentPage={page}
          totalCount={(workflowData && workflowData[1]) || 0}
          search={filter}
        />
      )}
    </>
  );
};

export default InternalQATab;
